import { createFileRoute, Link } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'
import { useT } from '@/i18n'
import { Chat } from '@/components/chat'
import { useThreadHeader } from '@/lib/messages'

// Spec 006. One conversation, client side.
export const Route = createFileRoute('/_client/messages_/$id')({ component: ClientConversation })

function ClientConversation() {
  const { id } = Route.useParams()
  const { t } = useT()
  const header = useThreadHeader(id)
  const h = header.data
  if (!header.isLoading && !h) return <p className="text-[14px] text-token-secondary">{t('msg.notFound')}</p>
  return (
    <div className="space-y-3">
      <Link to="/messages" className="inline-flex items-center gap-1 text-[13px] font-semibold text-token-secondary"><ChevronLeft className="h-4 w-4" />{t('msg.nav')}</Link>
      <div className="rounded-[14px] border border-token-subtle bg-token-surface px-4 py-3">
        <p className="text-[16px] font-bold text-token-primary">{h?.counterpart ?? ''}</p>
        <div className="flex flex-wrap gap-x-3 text-[12.5px]">
          {h?.task_title && h.task_id && <Link to="/tasks/$id" params={{ id: h.task_id }} className="text-token-secondary hover:underline">{t('msg.about', { task: h.task_title })}</Link>}
          {h?.counterpart_slug && <Link to="/p/$slug" params={{ slug: h.counterpart_slug }} className="font-semibold text-brand hover:underline">{t('tasks.viewProfile')}</Link>}
        </div>
      </div>
      <Chat threadId={id} mySide="client" labels={{
        placeholder: t('msg.placeholder'), send: t('msg.send'), masked: t('msg.masked'), maskWarning: t('msg.maskWarning'),
        photoProblem: t('msg.photoProblem'), empty: t('msg.empty'),
      }} />
    </div>
  )
}
